/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon32Regular = forwardRef('MediaAudioVolumeS0Icon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.501 5.748C15.468 4.885 17 5.57 17 6.867v18.266c0 1.296-1.532 1.982-2.499 1.12L8.619 21H4.75A2.75 2.75 0 0 1 2 18.25v-4.5A2.75 2.75 0 0 1 4.75 11h3.869L14.5 5.748ZM15 7.983l-5.05 4.509A2 2 0 0 1 8.62 13H4.75a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h3.869a2 2 0 0 1 1.332.508L15 24.017V7.983Z" })));
});
